export default __webpack_public_path__ + "assets/d8a7af7b9ea53bed5068504a37db818a.ttf";